import React, { useState, useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.rtl.min.css";

function Cost() {
  const [value, setValue] = useState("");
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const [dreamType, setDreamType] = useState("written"); // 'written' or 'audio'
  const [interpretationType, setInterpretationType] = useState("written"); // 'written' or 'audio'
  const [discountType, setDiscountType] = useState("percentage"); // 'percentage' or 'amount'
  const [discountValue, setDiscountValue] = useState(0);
  const [finalCost, setFinalCost] = useState(0);
  const [initialCost, setInitialCost] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [units, setUnits] = useState(0);

  // دالة لقطع الرقم إلى عدد محدد من الأرقام العشرية دون التقريب لأعلى
  function truncateToDecimals(num, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.floor(num * factor) / factor;
  }

  const calculateCost = () => {
    let tempUnits = 0;
    let costPerUnit = 0;
    let baseCost = 0;

    if (interpretationType === "audio") {
      costPerUnit = 12;
      if (dreamType === "written") {
        if (value.length > 0) {
          tempUnits = value.length / 70;
          tempUnits = truncateToDecimals(tempUnits, 2);
          baseCost = tempUnits * costPerUnit;
        }
      } else if (dreamType === "audio") {
        const totalSeconds =
          parseInt(minutes || 0) * 60 + parseInt(seconds || 0);
        if (totalSeconds > 0) {
          tempUnits = totalSeconds / 12;
          tempUnits = truncateToDecimals(tempUnits, 2);
          baseCost = tempUnits * costPerUnit;
        }
      }
    } else if (interpretationType === "written") {
      costPerUnit = 8;
      if (dreamType === "written") {
        if (value.length > 0) {
          tempUnits = value.length / 70;
          tempUnits = truncateToDecimals(tempUnits, 2);
          baseCost = tempUnits * costPerUnit;
        }
      }
    }

    // تطبيق الخصم
    let tempDiscountAmount = 0;
    if (discountValue > 0) {
      if (discountType === "percentage") {
        tempDiscountAmount = (baseCost * discountValue) / 100;
      } else if (discountType === "amount") {
        tempDiscountAmount = discountValue;
      }
    }

    const totalCost = baseCost - tempDiscountAmount;
    setInitialCost(baseCost);
    setDiscountAmount(tempDiscountAmount);
    setFinalCost(totalCost >= 0 ? Math.floor(totalCost) : 0);
    setUnits(tempUnits);
  };

  useEffect(() => {
    calculateCost();
  }, [
    interpretationType,
    dreamType,
    value,
    minutes,
    seconds,
    discountType,
    discountValue,
  ]);

  const notify = () =>
    toast("تم النسخ إلى الحافظة", {
      position: "top-left",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const duration = `${minutes ? minutes : "0"}:${
    seconds ? (seconds < 10 ? "0" + seconds : seconds) : "00"
  }`;

  // دالة للحصول على الصيغة الصحيحة لكلمة "درهم"
  const getCurrencyWord = (amount) => {
    amount = Math.abs(Math.floor(amount)); // التأكد من أن المبلغ رقم صحيح وموجب
    if (amount >= 3 && amount <= 10) {
      return "دراهم";
    } else if (amount >= 11 && amount <= 99) {
      return "درهماً";
    } else {
      return "درهم";
    }
  };

  const copiedText = (() => {
    let text = "";

    // التكلفة أولاً
    if (discountValue > 0 && discountAmount > 0) {
      text += `المبلغ المستحق بعد الخصم: ${finalCost.toFixed(
        2
      )} ${getCurrencyWord(finalCost)} (شامل ضريبة القيمة المضافة)\n`;
      text += `التكلفة الإجمالية قبل الخصم: ${initialCost.toFixed(
        2
      )} ${getCurrencyWord(initialCost)}\n`;
      if (discountType === "percentage") {
        text += `الخصم (${discountValue}%‏): ${discountAmount.toFixed(
          2
        )} ${getCurrencyWord(discountAmount)}\n`;
      } else if (discountType === "amount") {
        text += `الخصم: ${discountAmount.toFixed(
          2
        )} ${getCurrencyWord(discountAmount)}\n`;
      }
    } else {
      text += `التكلفة: ${finalCost.toFixed(2)} ${getCurrencyWord(
        finalCost
      )} (تشمل ضريبة القيمة المضافة)\n`;
    }

    // التفاصيل تحت التكلفة
    text += `نوع الحلم: ${dreamType === "written" ? "كتابي" : "صوتي"}\n`;
    text += `نوع التفسير: ${
      interpretationType === "written" ? "كتابي" : "صوتي"
    }\n`;

    if (dreamType === "written") {
      text += `عدد الحروف: ${value.length}\n`;
    } else if (dreamType === "audio") {
      text += `مدة التسجيل: ${duration}\n`;
    }

    // إضافة وصف لطريقة الحساب
    text += `طريقة الحساب: `;
    if (interpretationType === "audio" && dreamType === "written") {
      text += `تفسير صوتي لحلم كتابي من 1-70 حرفًا = 12 درهمًا\n`;
      text += `عدد الوحدات: ${units}\n`;
    } else if (interpretationType === "audio" && dreamType === "audio") {
      text += `تفسير صوتي لحلم صوتي من 1-12 ثانية = 12 درهمًا\n`;
      text += `عدد الوحدات: ${units}\n`;
    } else if (interpretationType === "written" && dreamType === "written") {
      if (value.length <= 70) {
        text += `تفسير كتابي لحلم كتابي من 1-70 حرفًا = 8 دراهم\n`;
      } else {
        text += `تفسير كتابي لحلم كتابي لكل 70 حرفًا = 8 دراهم\n`;
      }
      text += `عدد الوحدات: ${units}\n`;
    }

    return text;
  })();

  return (
    <div className="container mt-5" dir="rtl">
      <h2 className="text-center mb-4">حساب تكلفة تفسير الأحلام</h2>
      <div className="card p-4">
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label">نوع الحلم:</label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="dreamType"
                id="dreamTypeWritten"
                value="written"
                checked={dreamType === "written"}
                onChange={(e) => {
                  setDreamType(e.target.value);
                  setValue("");
                  setMinutes("");
                  setSeconds("");
                  setFinalCost(0);
                  setInitialCost(0);
                  setDiscountAmount(0);
                  setUnits(0);
                }}
              />
              <label className="form-check-label" htmlFor="dreamTypeWritten">
                كتابي
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="dreamType"
                id="dreamTypeAudio"
                value="audio"
                checked={dreamType === "audio"}
                onChange={(e) => {
                  setDreamType(e.target.value);
                  setValue("");
                  setMinutes("");
                  setSeconds("");
                  setFinalCost(0);
                  setInitialCost(0);
                  setDiscountAmount(0);
                  setUnits(0);
                }}
              />
              <label className="form-check-label" htmlFor="dreamTypeAudio">
                صوتي
              </label>
            </div>
          </div>
          <div className="col-md-6"></div>
          <div className="col-md-3">
            <label className="form-label">نوع التفسير:</label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="interpretationType"
                id="interpretationTypeWritten"
                value="written"
                checked={interpretationType === "written"}
                onChange={(e) => {
                  setInterpretationType(e.target.value);
                  setFinalCost(0);
                  setInitialCost(0);
                  setDiscountAmount(0);
                  setUnits(0);
                }}
              />
              <label className="form-check-label" htmlFor="interpretationTypeWritten">
                كتابي
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="interpretationType"
                id="interpretationTypeAudio"
                value="audio"
                checked={interpretationType === "audio"}
                onChange={(e) => {
                  setInterpretationType(e.target.value);
                  setFinalCost(0);
                  setInitialCost(0);
                  setDiscountAmount(0);
                  setUnits(0);
                }}
              />
              <label className="form-check-label" htmlFor="interpretationTypeAudio">
                صوتي
              </label>
            </div>
          </div>
        </div>

        {dreamType === "written" && (
          <div className="mb-4 position-relative">
            <label className="form-label">أدخل نص الحلم:</label>
            <TextareaAutosize
              style={{ textAlign: "right" }}
              className="form-control"
              maxRows={10}
              onChange={(e) => setValue(e.target.value)}
              value={value}
              placeholder="أدخل النص هنا"
            />
            {value && (
              <i
                onClick={() => {
                  setValue("");
                  setFinalCost(0);
                  setInitialCost(0);
                  setDiscountAmount(0);
                  setUnits(0);
                }}
                className="fa fa-times-circle"
                aria-hidden="true"
                style={{
                  color: "red",
                  fontSize: 24,
                  cursor: "pointer",
                  position: "absolute",
                  right: "10px",
                  top: "35px",
                }}
              ></i>
            )}
          </div>
        )}

        {dreamType === "audio" && (
          <div className="mb-4 position-relative">
            <label className="form-label">مدة التسجيل:</label>
            <div className="row">
              <div className="col-6">
                <input
                  max={59}
                  min={0}
                  type="number"
                  className="form-control"
                  placeholder="دقائق"
                  onChange={(v) => setMinutes(v.target.value)}
                  value={minutes}
                />
              </div>
              <div className="col-6">
                <input
                  max={59}
                  min={0}
                  type="number"
                  className="form-control"
                  placeholder="ثوان"
                  onChange={(v) => setSeconds(v.target.value)}
                  value={seconds}
                />
              </div>
            </div>
            {(seconds || minutes) && (
              <i
                onClick={() => {
                  setMinutes("");
                  setSeconds("");
                  setFinalCost(0);
                  setInitialCost(0);
                  setDiscountAmount(0);
                  setUnits(0);
                }}
                className="fa fa-times-circle"
                aria-hidden="true"
                style={{
                  color: "red",
                  fontSize: 24,
                  cursor: "pointer",
                  position: "absolute",
                  right: "10px",
                  top: "35px",
                }}
              ></i>
            )}
          </div>
        )}

        {/* قسم الخصم */}
        <div className="mb-4">
          <label className="form-label">الخصم:</label>
          <div className="row">
            <div className="col-md-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="discountType"
                  id="discountTypePercentage"
                  value="percentage"
                  checked={discountType === "percentage"}
                  onChange={(e) => {
                    setDiscountType(e.target.value);
                    setDiscountValue(0);
                    setDiscountAmount(0);
                  }}
                />
                <label className="form-check-label" htmlFor="discountTypePercentage">
                  نسبة مئوية (%)
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="discountType"
                  id="discountTypeAmount"
                  value="amount"
                  checked={discountType === "amount"}
                  onChange={(e) => {
                    setDiscountType(e.target.value);
                    setDiscountValue(0);
                    setDiscountAmount(0);
                  }}
                />
                <label className="form-check-label" htmlFor="discountTypeAmount">
                  مبلغ ثابت (درهم)
                </label>
              </div>
            </div>
            <div className="col-md-6">
              <input
                type="number"
                min="0"
                className="form-control"
                placeholder={
                  discountType === "percentage"
                    ? "أدخل نسبة الخصم (%)"
                    : "أدخل مبلغ الخصم (درهم)"
                }
                value={discountValue}
                onChange={(e) =>
                  setDiscountValue(parseFloat(e.target.value) || 0)
                }
              />
            </div>
          </div>
        </div>

        {/* عرض تفاصيل التكلفة */}
        {finalCost > 0 && (
          <div className="mb-4">
            {discountValue > 0 && discountAmount > 0 ? (
              <>
                <h4>
                  المبلغ المستحق بعد الخصم: {Math.floor(finalCost)}{" "}
                  {getCurrencyWord(finalCost)} (شامل ضريبة القيمة المضافة)
                </h4>
                <p>
                  التكلفة الإجمالية قبل الخصم: {Math.floor(initialCost)}{" "}
                  {getCurrencyWord(initialCost)} <br />
                  الخصم (
                  {discountType === "percentage"
                    ? `${discountValue}%‏`
                    : `${Math.floor(discountAmount)} ${getCurrencyWord(
                        discountAmount
                      )}`}
                  ): {Math.floor(discountAmount)}{" "}
                  {getCurrencyWord(discountAmount)}
                </p>
              </>
            ) : (
              <h4>
                التكلفة: {Math.floor(finalCost)} {getCurrencyWord(finalCost)}{" "}
                (تشمل ضريبة القيمة المضافة)
              </h4>
            )}

            <h5>تفاصيل التكلفة:</h5>
            <table className="table">
              <tbody>
                <tr>
                  <td>نوع الحلم</td>
                  <td>{dreamType === "written" ? "كتابي" : "صوتي"}</td>
                </tr>
                <tr>
                  <td>نوع التفسير</td>
                  <td>
                    {interpretationType === "written" ? "كتابي" : "صوتي"}
                  </td>
                </tr>
                {dreamType === "written" && (
                  <tr>
                    <td>عدد الحروف</td>
                    <td>{value.length}</td>
                  </tr>
                )}
                {dreamType === "audio" && (
                  <tr>
                    <td>مدة التسجيل</td>
                    <td>{duration}</td>
                  </tr>
                )}
                {(interpretationType === "audio" ||
                  (interpretationType === "written" &&
                    dreamType === "written")) && (
                  <tr>
                    <td>طريقة الحساب</td>
                    <td>
                      {interpretationType === "audio" &&
                      dreamType === "written"
                        ? "تفسير صوتي لحلم كتابي من 1-70 حرفًا = 12 درهمًا"
                        : interpretationType === "audio" &&
                          dreamType === "audio"
                        ? "تفسير صوتي لحلم صوتي من 1-12 ثانية = 12 درهمًا"
                        : value.length <= 70
                        ? "تفسير كتابي لحلم كتابي من 1-70 حرفًا = 8 دراهم"
                        : "تفسير كتابي لحلم كتابي لكل 70 حرفًا = 8 دراهم"}
                    </td>
                  </tr>
                )}
                {units > 0 && (
                  <tr>
                    <td>عدد الوحدات</td>
                    <td>{units}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <CopyToClipboard text={copiedText} onCopy={notify}>
          <button className="btn btn-primary">نسخ المعلومات</button>
        </CopyToClipboard>
      </div>

      <ToastContainer rtl />
    </div>
  );
}

export default Cost;
